import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import { useOnFeatureClearingStates } from '../../../../shared/hooks/use-on-feature-clearing-states/use-on-feature-clearing-states.hook';
import { useRouteRedirect } from '../../../../shared/hooks/use-route-redirect/use-route-redirect.hook';
import SnackBarContextProvider from '../../../shared/components/snack-bar-context/SnackBarContext';
import Container from '../../../shared/components/ui/Container';
import Typography from '../../../shared/components/ui/Typography';
import {
  clearFirmwareFilters,
  clearFirmwaresState,
} from '../../store/slices/firmware.slice';

const FirmwarePageLayout = (): JSX.Element => {
  const location = useLocation();
  const isOnCreate = location.pathname.startsWith(
    '/firmware-management/create'
  );

  const isOnFirmwarePage = location.pathname.startsWith(
    '/firmware-management/firmwares'
  );

  useOnFeatureClearingStates([clearFirmwareFilters(), clearFirmwaresState()]);

  useRouteRedirect('/firmware-management', 'firmwares');

  return (
    <Container
      maxWidth={false}
      sx={{
        mt: 3,
        mr: 'unset',
        ml: 'unset',
        boxSizing: 'unset',
        padding: 0,
        ['@media(min-width: 600px)']: {
          padding: 0,
        },
      }}
    >
      <SnackBarContextProvider>
        <Typography
          variant="h1"
          sx={{
            fontSize: '32px',
            fontWeight: 300,
            marginTop: '54px',
            marginBottom: '11px',
          }}
        >
          {isOnFirmwarePage
            ? 'Firmware'
            : isOnCreate
            ? 'Add New Firmware'
            : 'Edit Firmware'}
        </Typography>

        <Outlet />
      </SnackBarContextProvider>
    </Container>
  );
};

export default FirmwarePageLayout;
